export default __webpack_public_path__ + "static/media/ic_matic_24.bb2e63e4.svg";